export const SET_ADD_LOCATION = 'SET_ADD_LOCATION';
export const ADD_LOCATION_START = 'ADD_LOCATION_START';
export const ADD_LOCATION_SUCCESS = 'ADD_LOCATION_SUCCESS';
export const ADD_LOCATION_FAILURE = 'ADD_LOCATION_FAILURE';
export const SET_LOCATIONS = 'SET_LOCATIONS';
export const INITIAL_LOCATIONS = 'INITIAL_LOCATIONS';
export const FETCH_LOCATIONS_START = 'FETCH_LOCATIONS_START';
export const FETCH_LOCATIONS_SUCCESS = 'FETCH_LOCATIONS_SUCCESS';
export const FETCH_LOCATIONS_FAILURE = 'FETCH_LOCATIONS_FAILURE';
export const FETCH_LOCATIONS_LIST_START = 'FETCH_LOCATIONS_LIST_START';
export const FETCH_LOCATIONS_LIST_SUCCESS = 'FETCH_LOCATIONS_LIST_SUCCESS';
export const FETCH_LOCATIONS_LIST_FAILURE = 'FETCH_LOCATIONS_LIST_FAILURE';
export const SET_CURRENT_LOCATION = 'SET_CURRENT_LOCATION';
export const SET_EDIT_LOCATION = 'SET_EDIT_LOCATION';
export const SET_EDIT_LOCATION_SUCCESS = 'SET_EDIT_LOCATION_SUCCESS';
